import React from 'react';

import TextExpander from 'components/TextExpander';
import { TombstoneText } from 'components/Tombstone';
import {
  StyledDivider,
  StyledSection,
  Label,
  StyledTextBody
} from 'components/TabbedHeaderLayout/Sidebar';
import { getActiveYears } from 'helpers';
import CommaList from 'components/CommaList';
import { GetLabelAndViewerQuery } from 'gql/graphql';

interface LabelDetailsProps {
  label: NonNullable<GetLabelAndViewerQuery['label']>;
  truncate?: boolean;
  loading: boolean;
}

const LabelDetails = ({ label, truncate = false, loading }: LabelDetailsProps) => {
  //render tombstones
  if (loading || !label) {
    return (
      <div>
        <StyledSection>
          <Label>About</Label>

          <div data-testid="label-bio" style={{ display: 'grid', gap: '.8rem' }}>
            <TombstoneText />
            <TombstoneText />
          </div>
        </StyledSection>

        <StyledDivider />

        <StyledSection>
          <Label>Active on Proton</Label>
          <div data-testid="label-active-range">
            <TombstoneText />
          </div>
        </StyledSection>

        <StyledSection>
          <Label>Genres</Label>

          <div data-testid="label-genres">
            <TombstoneText />
          </div>
        </StyledSection>
      </div>
    );
  }

  const { description, genres = [], activeStartYear, activeEndYear } = label;
  const activeYears = getActiveYears(String(activeStartYear), String(activeEndYear));

  return (
    <div>
      {description && (
        <>
          <StyledSection>
            <Label>About</Label>

            <div data-testid="label-bio">
              {truncate ? (
                <TextExpander startHeight={120}>{description}</TextExpander>
              ) : (
                <StyledTextBody>{description}</StyledTextBody>
              )}
            </div>
          </StyledSection>

          <StyledDivider />
        </>
      )}

      {activeYears && (
        <StyledSection>
          <Label>Active on Proton</Label>
          <p data-testid="label-active-range">{activeYears}</p>
        </StyledSection>
      )}

      {genres.length > 0 && (
        <StyledSection>
          <Label>Genres</Label>

          <p data-testid="label-genres">
            <CommaList data={genres} attribute="name" />
          </p>
        </StyledSection>
      )}
    </div>
  );
};

export default LabelDetails;
